module.exports = "/packs/images/homepage/facilities/library_tablet~50b2694bf4078dad4da16a2afa624017.jpg";